import $ from 'jquery';
import 'intl-tel-input/build/js/intlTelInput';
import 'intl-tel-input/build/js/utils';
import debounce from 'lodash/debounce';

import { formatUsPhone } from './usPhone';

const DEBOUNCE_INTERVAL = 50;
const PHONE_INPUT_SELECTOR = '[data-mask-phone]';
export const PREFERRED_PHONE_COUNTRIES = ['us'];

export function setPhoneValidity ($phone, isValid = true) {
  // add custom error for HTML5
  const invalidMessage = 'Phone number is not a valid US smartphone';
  // blank string means valid
  const validMessage = '';

  $phone[0].setCustomValidity(isValid ? validMessage : invalidMessage);
}

function updatePhoneValidity ($phone) {
  const isValid = (!$phone.val() && !$phone.attr('required')) || $phone.intlTelInput('isValidNumber');
  setPhoneValidity($phone, isValid);
}

function maskAndValidatePhoneInput () {
  const $phone = $(this);
  updatePhoneValidity($phone);
  // Display as XXX-XXX-XXXX (matches the vui forms / result-submission field)
  // instead of intl-tel's national parens format. The country stays US, so
  // isValidNumber/getNumber still parse the dashed value correctly.
  $phone.val(formatUsPhone($phone.val()));
}

export function initIntlTelInput () {
  const $phone = $(PHONE_INPUT_SELECTOR);
  // the vendor library nests the input so that its next sibling is no longer its label.
  // Let's move the label, too - our CSS depends on it!
  const $labelAndError = $phone.siblings('label, .opt-form__error--input');

  // initialize vendor library
  $phone.intlTelInput({
    allowDropdown: false,
    nationalMode: true,
    preferredCountries: PREFERRED_PHONE_COUNTRIES,
    customPlaceholder () {
      return 'XXX-XXX-XXXX';
    },
  });

  // intl-tel-input always renders a country flag; there is no option to remove
  // it. For US-only UX we hide the flag/selector entirely and reclaim the left
  // padding the plugin reserved for it. The selected country stays US
  // internally, so getNumber/isValidNumber continue to work.
  $phone.each((i, el) => {
    const $input = $(el);
    $input.closest('.intl-tel-input').find('.flag-container').hide();
    $input.css('padding-left', '');
    // Format any pre-filled value as XXX-XXX-XXXX.
    $input.val(formatUsPhone($input.val()));
  });

  $labelAndError.insertAfter($phone);
}

function attachPhoneContext () {
  $(window).on('turbolinks:load', initIntlTelInput);
  $(document).on('keyup change', PHONE_INPUT_SELECTOR, debounce(maskAndValidatePhoneInput, DEBOUNCE_INTERVAL));
}

export default attachPhoneContext;
